document.addEventListener('DOMContentLoaded', function () {

  const themeBtn = document.getElementById('theme-toggle');
  if (themeBtn) {
    initThemeToggle(themeBtn);
  }

  const tickerBar = document.getElementById('tickerBar');
  const tickerClose = document.getElementById('tickerClose');
  if (tickerBar && tickerClose) {
    initTickerClose(tickerBar, tickerClose);
  }

  const articleShareFloat = document.getElementById('artShareFloat');
  const articleShareEnd = document.getElementById('artShareEnd');
  const articleShareHero = document.getElementById('artShareHero');
  if (articleShareFloat || articleShareEnd || articleShareHero) {
    initArticleShare([articleShareFloat, articleShareEnd, articleShareHero]);
  }

  const trendingBar = document.getElementById('trendingBar');
  const trendingScroll = document.getElementById('trendingScroll');
  const trendingPrev = document.getElementById('trendingPrev');
  const trendingNext = document.getElementById('trendingNext');
  if (trendingBar && trendingScroll && trendingPrev && trendingNext) {
    initTrendingBar(trendingBar, trendingScroll, trendingPrev, trendingNext);
  }

  const nlPageCards = document.querySelectorAll('#nlPageCards .nl-page-card');
  const nlPageSelectAll = document.getElementById('nlPageSelectAll');
  const nlPageClear = document.getElementById('nlPageClear');
  const nlBottomBar = document.getElementById('nlBottomBar');
  const nlBottomCount = document.getElementById('nlBottomCount');
  const nlBottomTypes = document.getElementById('nlBottomTypes');
  const nlBottomClose = document.getElementById('nlBottomClose');
  if (nlPageCards.length && nlPageSelectAll && nlBottomBar && nlBottomCount && nlBottomTypes && nlBottomClose) {
    initNewslettersPage(nlPageCards, nlPageSelectAll, nlPageClear, nlBottomBar, nlBottomCount, nlBottomTypes, nlBottomClose);
  }

  const nlCards = document.querySelectorAll('#nlCards .nl-card');
  const nlTypes = document.getElementById('nlTypes');
  const nlHint = document.getElementById('nlHint');
  const nlSubmit = document.getElementById('nlSubmit');
  if (nlCards.length && nlTypes && nlHint && nlSubmit) {
    initNewsletterBanner(nlCards, nlTypes, nlHint, nlSubmit);
  }

  const headerSearch = document.getElementById('headerSearch');
  const headerSearchBtn = document.getElementById('headerSearchBtn');
  const headerSearchClear = document.getElementById('headerSearchClear');
  const headerSearchInput = document.getElementById('headerSearchInput');
  if (headerSearch && headerSearchBtn && headerSearchClear && headerSearchInput) {
    initHeaderSearch(headerSearch, headerSearchBtn, headerSearchClear, headerSearchInput);
  }

  const sideNavBtn = document.getElementById('sideNavBtn');
  const sideNav = document.getElementById('sideNav');
  const sideNavBackdrop = document.getElementById('sideNavBackdrop');
  const sideNavClose = document.getElementById('sideNavClose');
  if (sideNavBtn && sideNav && sideNavBackdrop && sideNavClose) {
    initSideNav(sideNavBtn, sideNav, sideNavBackdrop, sideNavClose);
  }

  const scrollTopBtn = document.getElementById('scrollTopBtn');
  if (scrollTopBtn) {
    initScrollToTop(scrollTopBtn);
  }

  const authorLoadMore = document.getElementById('authorLoadMore');
  const authorPostList = document.getElementById('authorPostList');
  if (authorLoadMore && authorPostList) {
    initAuthorLoadMore(authorLoadMore, authorPostList);
  }

  const keepReadingSentinel = document.getElementById('keep-reading-sentinel');
  if (keepReadingSentinel) {
    initKeepReading(keepReadingSentinel);
  }

  const artBeaconEl = document.querySelector('[data-art-id]');
  if (artBeaconEl) {
    initPageViewBeacon(artBeaconEl.dataset.artId);
  }

  const cookieBanner = document.getElementById('cookieBanner');
  const cookieAccept = document.getElementById('cookieAccept');
  const cookieReject = document.getElementById('cookieReject');
  if (cookieBanner && cookieAccept && cookieReject) {
    initCookieBanner(cookieBanner, cookieAccept, cookieReject);
  }

  const footerNlWrap = document.querySelector('[data-footer-nl]');
  if (footerNlWrap) initFooterNl(footerNlWrap);

  const nwCard = document.querySelector('[data-nw]');
  if (nwCard) initNlDispatch(nwCard);

  const ndlCard = document.querySelector('[data-ndl]');
  if (ndlCard) initNlDetail(ndlCard);

  document.querySelectorAll('form[data-nl-form]').forEach(function (form) {
    subscribeNl(form);
  });

  initCodeCopy();
  initTwitterEmbeds();
  initInstagramEmbeds();
  initThreadsEmbeds();
  initGalleryLightbox();
  initImageZoom();
  initTocScrollSpy();

  const relativeTimeEls = document.querySelectorAll('.js-relative-time');
  if (relativeTimeEls.length) {
    initRelativeTimestamps(relativeTimeEls);
  }
});

